export function Home() {
  return (
    <main className="mx-auto flex min-h-dvh max-w-md flex-col items-center justify-center gap-6 px-6 text-center">
      <img src="/icon.svg" alt="" className="animate-spin-slow h-28 w-28" />
      <h1 className="font-display text-4xl font-bold">
        <span className="text-gradient">KaroZik</span>
      </h1>
      <p className="text-lg text-ink-dim">Ce soir, c’est vous le DJ.</p>
      <p className="glass rounded-2xl px-5 py-4 text-ink-dim">
        📷 Scanne le QR code affiché dans la salle ou posé sur ta table pour rejoindre la playlist.
      </p>
    </main>
  );
}
